export const sortKeys = (keys: string[], values: any) => {
  return keys?.sort((a: string, b: string) => {
    const aIndex = values?.[a]?.index;
    const bIndex = values?.[b]?.index;
    return aIndex - bIndex;
  });
};
